var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoltar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "voltar",
    transform: "translate(-451 -100)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_138",
    "data-name": "Elipse 138",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(451 100)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_271228_1_",
    "data-name": "right-arrow_271228 (1)",
    transform: "translate(485.878 142.039) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_973",
    "data-name": "Grupo 973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1468",
    "data-name": "Caminho 1468",
    d: "M17.052,13.754,3.775.477a1.636,1.636,0,0,0-2.308,0l-.978.978a1.634,1.634,0,0,0,0,2.308L11.638,14.912.477,26.073a1.636,1.636,0,0,0,0,2.308l.978.977a1.636,1.636,0,0,0,2.308,0L17.052,16.07a1.647,1.647,0,0,0,0-2.316Z",
    fill: "#640000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltar);
export default __webpack_public_path__ + "static/media/voltar.761da4ba1d750b743a59eab8359ddb32.svg";
export { ForwardRef as ReactComponent };